<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="row">
    <div class="col col-xs-12 col-sm-4">
      <div class="input">
        <app-label [control]="vorname" class="input__label" for="vorname">Vorname:</app-label>
        <mat-form-field>
          <input matInput id="vorname" formControlName="vorname">
          <mat-error *ngIf="vorname.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-4">
      <div class="input">
        <app-label [control]="nachname" class="input__label" for="nachname">Nachname:</app-label>
        <mat-form-field>
          <input matInput id="nachname" formControlName="nachname">
          <mat-error *ngIf="nachname.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-4">
      <div class="input">
        <app-label [control]="geburtsdatum" class="input__label" for="geburtsdatum">Geburtsdatum:</app-label>
        <mat-form-field>
          <input matInput id="geburtsdatum" [matDatepicker]="geburtsdatumPicker" [min]="geburtsdatumMinDate" [max]="geburtsdatumMaxDate" placeholder="TT.MM.JJJJ" formControlName="geburtsdatum">
          <mat-datepicker-toggle matSuffix [for]="geburtsdatumPicker"></mat-datepicker-toggle>
          <mat-datepicker #geburtsdatumPicker></mat-datepicker>
          <mat-error *ngIf="geburtsdatum.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          <mat-error *ngIf="geburtsdatum.hasError('matDatepickerMin')">{{ 'MINVALUE' | translate:{'value': geburtsdatumMinDate | date} }}</mat-error>
          <mat-error *ngIf="geburtsdatum.hasError('matDatepickerMax')">{{ 'MAXVALUE' | translate:{'value': geburtsdatumMaxDate | date} }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
